export default "__VITE_ASSET__Bo53tXMU__"